import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GeneralService } from '../services/general.service';
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
    private baseUrl;
    constructor(private _generalService: GeneralService){
        this.baseUrl = this._generalService.baseUrl;
    }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    request = request.clone({
        url: this.baseUrl + request.url,
        withCredentials: true
    });
    return next.handle(request);
  }
}